export enum Theme {
  Avocado = 'Avocado',
  Blueberry = 'Blueberry',
  Grape = 'Grape',
}
